import { Routes } from '@angular/router';
import { environment } from 'src/environments/environment';
import * as Admin from './admin/admin.components';
import { CommonAtcComponent } from './common/atc/common.atc.component';
import { CommonMedicineComponent } from './common/atc/medicine/common.medicine.component';
import { CieComponent as CommonCieComponent } from './common/cie/cie.component';
import { DoctorMainComponent } from './common/doctor/components/doctor-main.component';
import { PatientMainComponent } from './common/patient/components/patient-main.component';
import { PersonMainComponent } from './common/person/components/person-main.component';
import { TurnComponent } from './common/turn/components/turn.main.component';
import * as General from './general/general.components';
import { OdontoMainComponent } from './odontology/odonto.component';
import { PatientsByDoctorComponent } from './report/patients-by-doctor/patients-by-doctor.component';
import { CieComponent as ReportCieComponent } from './report/report.components';

export const ADMINISTRATION_ROUTES: Routes = [
  {
    path: 'admin',
    children: [
      {
        path: 'sistema',
        children: [
          { path: 'catalogo', component: Admin.CatalogComponent },
          { path: 'catalogo/:code', component: Admin.SubCatalogComponent },
          {
            path: 'ubicaciones-geograficas',
            component: Admin.LocationComponent,
          },
        ],
      },
      {
        path: 'general',
        children: [
          { path: 'persona', component: PersonMainComponent },
          { path: 'doctor', component: DoctorMainComponent },
          { path: 'paciente', component: PatientMainComponent },
          { path: 'cie', component: CommonCieComponent },
          { path: 'atc', component: CommonAtcComponent },
          { path: 'atc/:id', component: CommonMedicineComponent },
        ],
      },
    ],
  },
];

export const KHUYANA_ROUTES: Routes = [
  { path: 'turno', component: TurnComponent },
  { path: 'signos-vitales', component: General.VitalSignComponent },
  { path: 'consulta', component: General.ConsultComponent },
];

if (environment.modules.odontology) {
  KHUYANA_ROUTES.push({
    path: 'odontologia',
    component: OdontoMainComponent,
  });
}

export const REPORT_ROUTES: Routes = [
  {
    path: 'reporte',
    children: [
      { path: 'pacientes-por-doctor', component: PatientsByDoctorComponent },
      { path: 'cie', component: ReportCieComponent },
    ],
  },
];
